import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from './client';

export interface ExportData {
    version: string;
    exportedAt: string;
    persons: {
        id: string;
        fullName: string;
        givenName: string | null;
        gender: string | null;
        birthDate: string | null;
        deathDate: string | null;
        notes: string | null;
        photoUrl: string | null;
    }[];
    relationships: {
        parentChild: { parentId: string; childId: string }[];
        spouse: { personA: string; personB: string }[];
    };
}

export interface ImportResult {
    success: boolean;
    personsImported: number;
    relationshipsImported: number;
}

export const exportData = async (): Promise<ExportData> => {
    const { data } = await apiClient.get<ExportData>('/export');
    return data;
};

export const useImportData = () => {
    const queryClient = useQueryClient();

    return useMutation<ImportResult, Error, ExportData>({
        mutationFn: async (data: ExportData) => {
            const { data: result } = await apiClient.post<ImportResult>('/import', data);
            return result;
        },
        onSuccess: () => {
            // Invalidate all queries to refresh tree, search, etc.
            queryClient.invalidateQueries();
        },
    });
};
